import { css } from "emotion";
import { Pivot, PivotItem } from "office-ui-fabric-react";
import React from "react";
import { AssignFilterItem } from "../../assign-page.store";

/**
 * Props
 */
export interface AssignFilterProps {
  filters: AssignFilterItem[];
  selectedFilterId?: string;
  filterChanged: (filterId: string) => void;
}

/**
 * アサインフィルター
 * @param filters
 * @param selectedFilterId
 * @param filterChanged
 * @constructor
 */
export const AssignFilter = ({
  filters,
  selectedFilterId,
  filterChanged
}: AssignFilterProps) => {
  const onLinkClick = (item?: PivotItem) => {
    if (item && item.props.itemKey) {
      filterChanged(item.props.itemKey);
    }
  };

  return (
    <Pivot
      headersOnly={true}
      selectedKey={selectedFilterId}
      onLinkClick={onLinkClick}
      className={css`
        background: #e1e1e1;
        padding-left: 19px;
      `}
      // https://github.com/OfficeDev/office-ui-fabric-react/issues/4066#issuecomment-487692074
      styles={{ root: { display: "flex", flexWrap: "wrap" } }}
    >
      {filters.map(v => (
        <PivotItem
          key={v.id}
          itemKey={v.id}
          headerText={v.label}
          itemIcon={v.icon}
          itemCount={v.itemCount}
        />
      ))}
    </Pivot>
  );
};
